import React from 'react';
import { formatdate } from '../../util/global';

const TableBatch = ({ batchdata, countmap, openbatch, exportbatch, deletebatch }: any) => {
  const rows = [];
  for (let i = 0; i < batchdata.length; i++) {
    const batch = batchdata[i];
    const counts = countmap[batch._id] || { lines: 0, pending: 0, approved: 0, flagged: 0 };

    let status = batch.status;
    if (batch.status == "processing") status = batch.step || "processing";
    if (batch.status == "failed") status = "failed at " + (batch.step || "?") + ": " + (batch.errormessage || "unknown error");

    const recon = [];
    for (let a = 0; batch.accounts && a < batch.accounts.length; a++) {
      const account = batch.accounts[a];
      recon.push(
        <div key={account.bankaccount} className={"recon-" + account.reconstatus}>
          {account.currency}: {account.reconstatus}
        </div>
      );
    }

    rows.push(
      <tr key={batch._id}>
        <td>
          <select
            className="action-select"
            value=""
            onChange={(e) => {
              if (e.target.value == "Open") openbatch(batch);
              if (e.target.value == "Export") exportbatch(batch);
              if (e.target.value == "Delete") deletebatch(batch);
            }}
          >
            <option value="">Select…</option>
            <option value="Open">Open</option>
            <option value="Export">Export Excel</option>
            <option value="Delete">Delete</option>
          </select>
        </td>
        <td>{batch.clientname}</td>
        <td>{batch.period}</td>
        <td>{batch.createdtimestamp ? formatdate(new Date(batch.createdtimestamp)) : ""}</td>
        <td className={"status-" + batch.status}>{status}</td>
        <td>{recon}</td>
        <td>{counts.lines}</td>
        <td>{counts.pending}</td>
        <td>{counts.approved}</td>
        <td>{counts.flagged}</td>
      </tr>
    );
  }
  if (rows.length == 0) {
    rows.push(
      <tr key="empty">
        <td colSpan={10} className="empty-row">No batches yet</td>
      </tr>
    );
  }

  return (
    <table className="grid">
      <thead>
        <tr>
          <th>action</th>
          <th>client</th>
          <th>period</th>
          <th>uploaded</th>
          <th>status</th>
          <th>recon</th>
          <th>lines</th>
          <th>pending</th>
          <th>approved</th>
          <th>flagged</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default TableBatch;
